import script from "./SingleDropZone.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleDropZone.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/nginx/domains/tools.androidrepublic.org/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"SingleDropZone.vue"]])

export default __exports__